<template>
  <b-row :class="`margin-0 ${rowClass}`">
    <b-col v-if="title" cols="12" md="12" class="padding-x-0">
      <div class="font-size-12 color-complementary-300 margin-bottom-8">
        {{ title }}
        <span v-if="infoTooltip" v-b-tooltip.hover :title="infoTooltip">
          <mdicon name="help-circle-outline" size="16" />
        </span>
      </div>
    </b-col>
    <b-col
      cols="12"
      md="12"
      class="position-relative padding-x-0 input"
      :class="{ 'ck-invalid': generateState !== null }"
    >
      <Editor
        :toolbarItems="toolbarItems"
        v-model="inputValue"
        :id="id"
        :disabled="disabled"
        :state="generateState"
        :aria-describedby="`${id}-help ${id}-feedback`"
        @blur="blur"
        @focus="focus"
      />
    </b-col>
    <b-col cols="12" md="12" class="padding-x-0">
      <FeedbackMessages
        :state="generateState"
        :label="label"
        :vuelidateObj="vuelidateObj"
      />
    </b-col>
  </b-row>
</template>

<script>
import Editor from "@/components/ckeditor/editor";
import FeedbackMessages from "../feedback-messages/FeedbackMessages.vue";
import { computed, toRefs } from "vue";

export default {
  components: { Editor, FeedbackMessages },
  props: {
    value: {}, // watch model
    name: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "عنوان",
    },
    id: {
      type: String,
      default: "default-id",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    vuelidateObj: {
      type: Object,
      default: null,
    },
    rowClass: {
      type: String,
      default: "margin-bottom-22",
    },
    infoTooltip: {
      type: String,
      default: "",
    },
    toolbarItems: {
      type: Array,
      default: () => [
        "alignment",
        "subscript",
        "superscript",
        "|",
        "blockQuote",
        "bulletedList",
        "numberedList",
        "todoList",
        "|",
        "undo",
        "redo",
      ],
    },
  },
  setup(props, { emit }) {
    // generate props data
    const {
      value,
      name,
      title,
      label,
      id,
      disabled,
      vuelidateObj,
      rowClass,
      infoTooltip,
      toolbarItems,
    } = toRefs(props);

    // watching input value
    const inputValue = computed({
      get() {
        return value.value;
      },
      set(val) {
        emit("input", name.value, val);
      },
    });

    const generateState = computed(() =>
      vuelidateObj.value && vuelidateObj.value.$error
        ? !vuelidateObj.value.$error
        : null
    );

    // action methods
    const blur = () => emit("blur", name.value, inputValue.value);
    const focus = () => emit("focus", name.value);

    // return data to be used in template
    return {
      value,
      name,
      title,
      label,
      id,
      disabled,
      vuelidateObj,
      rowClass,
      infoTooltip,
      toolbarItems,
      inputValue,
      generateState,
      blur,
      focus,
    };
  },
};
</script>
